module.exports = __webpack_public_path__ + "static/media/gabinets.06657e57.svg";